import { createTheme } from "@mui/material";

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2F49D1",
    },
    secondary: {
      main: "#B6C1E9",
      contrastText: "#B9B9B9",
    },
    divider: "#ffffff",
    background: {
      default: "#F0F2FA",
    },
    success: {
      main: "#4BDE97",
    },
    warning: {
      main: "#FFB648",
    },
    danger: {
      main: "#F26464",
    },
  },
});
const darkTheme = createTheme({
  palette: {
    mode: "dark",
   
    secondary: {
      main: "#ff4081",
      light: "#ff79b0",
      dark: "#c60055",
      contrastText: "#fff",
    },
    background: {
      default: "#212121",
      paper: "#424242",
    },
    text: {
      primary: "#fff",
      secondary: "#fff",
    },
    divider: "#bdbdbd",

    // custom
    success: {
      main: "#4caf50",
      light: "#81c784",
      dark: "#388e3c",
      contrastText: "#fff",
    },
    warning: {
      main: "#ff9800",
      light: "#ffb74d",
      dark: "#f57c00",
      contrastText: "#fff",
    },
    error: {
      main: "#f44336",
      light: "#e57373",
      dark: "#d32f2f",
      contrastText: "#fff",
    },
    info: {
      main: "#2196f3",
      light: "#64b5f6",
      dark: "#1976d2",
      contrastText: "#fff",
    },
  },
});

export { lightTheme,darkTheme };
